// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__Cj43J","loaderDisclosure":"button_loaderDisclosure__pW11a","loader":"button_loader__P7HRh"};